import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  loadSector,
  loadSeats,
  updateSector,
  createSeats,
  updateSeats
} from '~/state/modules/planimetry'
import { PaperContainer } from '~/views/shared'
import { CircularProgress, Typography } from '@material-ui/core'
import { SectorForm } from '../SectorForm'
import { ROUTES } from '~/views/routes'
import { SEATS_STATUS, PositionDescriptor } from 'config/constants'
import { updateSeatsGrid } from '../SeatsDistribution/SeatSettings/lib/utils'
import history from '~/config/history'
import { showSnackbarError, showSnackbarSuccess } from 'views/utils/snackbar'
import { cleanHexColor } from 'views/utils/functions'

export const SectorUpdatePage = ({ match, onSuccess }) => {
  const {
    sector,
    pendingSector,
    pendingSeats,
    pendingUpdateSector,
    seats,
    pendingCreateSeats,
    pendingUpdateSeats
  } = useSelector((state) => state.planimetry)
  const { locationId, layoutId, sectorId } = match.params

  const dispatch = useDispatch()

  const createSeatsPayload = (seats, newRows, newColumns) => {
    const updatedSeats = updateSeatsGrid(newRows, newColumns, seats).map(
      (seat) => ({
        Column: seat.column,
        Row: seat.row,
        IsSeat: true,
        Status: SEATS_STATUS[seat.status],
        Id: seat.id || null
      })
    )
    return {
      SectorId: sectorId,
      Column: newColumns,
      Row: newRows,
      Seats: updatedSeats
    }
  }

  const refreshSeats = async (newRows, newColumns) => {
    const payload = createSeatsPayload(seats, newRows, newColumns)
    const action = sector.Capacity === 0 ? createSeats : updateSeats
    await dispatch(action(payload))
  }

  const handleSubmit = async (values, { setSubmitting }) => {
    const { Column: newColumn, Row: newRow } = values
    try {
      setSubmitting(true)

      if (newColumn !== sector.Column || newRow !== sector.Row) {
        await refreshSeats(newRow, newColumn)
      }
      await dispatch(updateSector(values))

      onSuccess(locationId, layoutId)
      showSnackbarSuccess('Sector Actualizado!')
    } catch (error) {
      showSnackbarError(error)
    } finally {
      setSubmitting(false)
    }
  }

  const values = {
    SectorId: sectorId,
    SectorName: sector?.Name || '',
    Column: sector?.Column || '',
    ColumnDescriptor: sector?.ColumnDescriptor || PositionDescriptor.Numeric,
    Row: sector?.Row || '',
    RowDescriptor: sector?.RowDescriptor || PositionDescriptor.Numeric,
    ImageId: sector?.ImageId || '',
    ImageFile: sector?.ImageCdnUrl || null,
    LayoutId: layoutId,
    Color: cleanHexColor(sector?.Color)
  }

  useEffect(() => {
    async function fetchData() {
      await dispatch(loadSector(sectorId))
      await dispatch(loadSeats(sectorId))
    }

    fetchData().then()
    // eslint-disable-next-line
  }, [match])

  return (
    <PaperContainer title='Actualización de Sector'>
      {pendingSector || pendingSeats ? (
        <div style={{ display: 'flex', alignItems: 'center', margin: '1rem' }}>
          <CircularProgress size={24} style={{ marginRight: '1rem' }} />
          <Typography>Cargando...</Typography>
        </div>
      ) : (
        <SectorForm
          values={values}
          actionText='Actualizar'
          handleSubmit={handleSubmit}
          actionPending={
            pendingUpdateSector || pendingCreateSeats || pendingUpdateSeats
          }
          onCancel={() =>
            history.push(
              ROUTES.ADMIN.LOCATIONS.PLANIMETRY.SECTORS.INDEX.replace(
                ':locationId',
                locationId
              ).replace(':layoutId', layoutId)
            )
          }
        />
      )}
    </PaperContainer>
  )
}

export default SectorUpdatePage
